export type CreatorInterestStatus = "outreached" | "negotiating" | "interested" | "not-interested";

type CreatorInterestStatusMeta = {
	label: string;
	bg: string;
	color: string;
	border: string;
};

export const CREATOR_INTEREST_STATUS_OPTIONS: Array<{
	value: CreatorInterestStatus;
	label: string;
}> = [
	{ value: "outreached", label: "Outreached" },
	{ value: "negotiating", label: "Negotiating" },
	{ value: "interested", label: "Interested" },
	{ value: "not-interested", label: "Not Interested" },
];

export const CREATOR_INTEREST_STATUS_META: Record<CreatorInterestStatus, CreatorInterestStatusMeta> = {
	outreached: {
		label: "Outreached",
		bg: "#e6f4ff",
		color: "#1677ff",
		border: "#91caff",
	},
	negotiating: {
		label: "Negotiating",
		bg: "#fff7e6",
		color: "#fa8c16",
		border: "#ffd591",
	},
	interested: {
		label: "Interested",
		bg: "#f6ffed",
		color: "#52c41a",
		border: "#b7eb8f",
	},
	"not-interested": {
		label: "Not Interested",
		bg: "#fff1f0",
		color: "#ff4d4f",
		border: "#ffa39e",
	},
};

export const normalizeCreatorInterestStatus = (
	value: CreatorInterestStatus | boolean | string | null | undefined,
): CreatorInterestStatus | undefined => {
	if (value === null || value === undefined || value === "") {
		return undefined;
	}

	if (typeof value === "boolean") {
		return value ? "interested" : "not-interested";
	}

	const normalized = value.toLowerCase().replace(/[\s_]+/g, "-");
	if (normalized === "outreach") return "outreached";
	if (normalized === "outreached") return "outreached";
	if (normalized === "negotiating") return "negotiating";
	if (normalized === "interested") return "interested";
	if (normalized === "not-interested") return "not-interested";

	return undefined;
};

export const getCreatorInterestStatusLabel = (
	status: CreatorInterestStatus | boolean | string | null | undefined,
): string => {
	const normalized = normalizeCreatorInterestStatus(status);
	return normalized ? CREATOR_INTEREST_STATUS_META[normalized].label : "—";
};
